import { useQuery } from '@tanstack/react-query'
import { LobsterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys } from './queryKeys'

// ラベルマスタをidのリストで取得する
export const useQueryLabelMastersByIds = (ids: string[]) => {
  return useQuery({
    queryKey: queryKeys.labelMastersByIds(ids),
    queryFn: async () => {
      const response = await baseClient
        .getApi(LobsterApi, true)
        .getLabelInspections({ ids })
        .catch(handleHTTPError)
      return response.labelInspections ?? []
    },
    enabled: ids.length > 0,
  })
}
